<template>
  <a-tabs :activeKey="activeTab" @change="handleTabChange" style="background: #fff;">
    <a-tab-pane key="1" tab="基本信息">
      <a-spin :spinning="confirmLoading">
        <a-alert message="说明" show-icon type="info">
          <p slot="description">
            【企业简称】用于自动生成企业管理员账号，
            <span style="color: red">请勿重复</span>(没有简称可使用
            <span style="font-weight: bold">拼音首字母</span>代替)。联系人和联系电话会自动配置为企业管理员联系方式。
          </p>
        </a-alert>
        <j-form-container :disabled="formDisabled">
          <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
            <a-row>
              <a-col :span="12">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业名称" prop="corpName">
                  <a-input placeholder="请输入企业名称" v-model="model.corpName"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业简称" prop="shortName">
                  <a-input :disabled="!!model.id" placeholder="请输入企业简称" v-model="model.shortName"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人" prop="contact">
                  <a-input placeholder="请输入联系人" v-model="model.contact"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系电话" prop="phone">
                  <a-input placeholder="请输入联系电话" v-model="model.phone"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="已授权设备数量">
                  <a-input-number disabled style="width: 100%" v-model="authDevs.length" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="APP账号">
                  <a-input-number disabled style="width: 100%" v-model="userCount" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="登记车辆数">
                  <a-input-number disabled style="width: 100%" v-model="vehicleCount" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="支付方式" prop="payStrategy">
                  <j-dict-select-tag
                    @change="payStrategyChange"
                    dictCode="pay_strategy"
                    type="radioButton"
                    v-model="model.payStrategy"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-tooltip title="允许超用请填入-1">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="允许超用量" prop="overUsage">
                    <a-input-number placeholder="请输入允许超用量" style="width: 100%" v-model="model.overUsage" />
                  </a-form-model-item>
                </a-tooltip>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同存档" prop="files">
                  <j-upload :returnUrl="false" text="上传文件" v-model="model.files"></j-upload>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-tooltip title="合同约定时间，非激活时间">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="加入时间" prop="joinTime">
                    <j-date placeholder="请选择加入时间" style="width: 100%" v-model="model.joinTime" />
                  </a-form-model-item>
                </a-tooltip>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="禁止取水" prop="disabled">
                  <j-switch :options="[1, 0]" v-model="model.disabled"></j-switch>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="用途" prop="purpose">
                  <a-textarea placeholder="请输入用途" rows="4" v-model="model.purpose" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="备注" prop="remark">
                  <a-textarea placeholder="请输入备注" rows="4" v-model="model.remark" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </j-form-container>
      </a-spin>
    </a-tab-pane>

    <a-tab-pane :disabled="!model.id" key="2" tab="授权设备">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form-model @keydown.enter.native="searchQuery" @submit.native.prevent layout="inline">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item label="供水流域">
                <j-dict-select-tag
                  @change="searchQuery"
                  dictCode="`iwt-wf`.dev_process,process_name,id, del_flag = '0' order by sort"
                  placeholder="请选择供水流域"
                  v-model="queryParam.devProcessId"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="表号">
                <a-input placeholder="请输入表号" v-debounce="searchQuery" v-model="queryParam.devTag"></a-input>
              </a-form-model-item>
            </a-col>

            <a-col :md="3" :sm="8">
              <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
                <a-button @click="searchQuery" @keyup.enter.native="searchQuery" icon="search" type="primary">查询</a-button>
                <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <!-- 查询区域-END -->
      <!-- 操作按钮区域 -->
      <div class="table-operator" v-if="!disabled">
        <a-button @click="handleAddCorpAuth" icon="plus" type="primary">新增</a-button>
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item @click="cancelAuzBatch" key="1">
              <a-button icon="delete" type="danger">取消授权</a-button>
            </a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>
      <a-table
        :columns="columns"
        :dataSource="devDataList"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="pcaSlot" slot-scope="text">
          <div>{{ getPcaText(text) }}</div>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="cancelAuz(record)">取消授权</a>
        </span>
      </a-table>
    </a-tab-pane>

    <a-tab-pane :disabled="!model.id" key="3" tab="APP账号">
      <wf-consumer-user-list :disabled="disabled" :filter="childrenFilter"></wf-consumer-user-list>
    </a-tab-pane>

    <a-tab-pane :disabled="!model.id" key="4" tab="车辆台账">
      <wf-corp-vehicle-list :disabled="disabled" :filter="childrenFilter"></wf-corp-vehicle-list>
    </a-tab-pane>

    <a-tab-pane :disabled="!model.id" key="5" tab="充水量记录">
      <wf-consumer-corp-recharge-list :filter="childrenFilter"></wf-consumer-corp-recharge-list>
    </a-tab-pane>

    <a-tab-pane :disabled="!model.id" key="6" tab="加水记录">
      <wf-consumer-record-list :filter="childrenFilter"></wf-consumer-record-list>
    </a-tab-pane>

    <wf-dev-permission-list-modal @ok="authChange" ref="permissionModal"></wf-dev-permission-list-modal>
  </a-tabs>
</template>

<script>

  import { httpAction, getAction, deleteAction } from '@/api/manage'
  import { duplicateCheck } from '@/api/api'
  import { validateDuplicateValue } from '@/utils/util'
  import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'


  import WfConsumerUserList from "@/views/wf/WfConsumerUserList";
  import WfConsumerCorpRechargeList from "@/views/wf/WfConsumerCorpRechargeList";
  import WfConsumerRecordList from "@/views/wf/WfConsumerRecordList";
  import WfDevPermissionListModal from './WfDevPermissionListModal.vue'
  import WfCorpVehicleListVue from '@/views/wf/WfCorpVehicleList.vue'

  import Area from '@/components/_util/Area'
  import WfCorpVehicleList from '../WfCorpVehicleList.vue'

  export default {
    name: 'WfConsumerCorpForm',
    mixins: [JeecgListMixin],
    components: {
      WfConsumerUserList,
      WfConsumerCorpRechargeList,
      WfConsumerRecordList,
      WfDevPermissionListModal,
      WfCorpVehicleListVue,
      WfCorpVehicleList
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        activeTab: '1',
        model: {
          contractCycleUnit: 3,
          disabled: 0,
          overUsage: 0,
          payStrategy: 1,
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 }
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 }
        },
        ipagination: {
          pageSize: 50,
        },
        confirmLoading: false,
        validatorRules: {
          corpName: [
            { required: true, message: '请输入企业名称!' },
          ],
          shortName: [
            { required: true, message: '请输入企业简称!' },
            { validator: this.validateShortname, }
          ],
          contractVolume: [
            { required: true, message: '请输入合同用水量(吨)!' },
          ],
          disabled: [
            { required: true, message: '请输入禁止取水!' },
          ],
        },
        authDevs: [],
        devDataList: [],
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '设备名称',
            align: 'center',
            dataIndex: 'devName',
            sorter: true
          },
          {
            title: '表号',
            align: 'center',
            dataIndex: 'devTag',
            scopedSlots: { customRender: 'devTagSlot' },
            sorter: true
          },
          {
            title: '区域',
            align: 'center',
            dataIndex: 'region',
            sorter: true,
            scopedSlots: { customRender: 'pcaSlot' }
          },
          {
            title: '供水流域',
            align: 'center',
            dataIndex: 'devProcessId_dictText',
            sorter: true
          },
          {
            title: '安装位置',
            align: 'left',
            dataIndex: 'location',
            scopedSlots: { customRender: 'locationSlot' },
            sorter: true
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        isorter: {
          column: 'sort',
          order: 'asc'
        },
        url: {
          add: "/wf/wfConsumerCorp/add",
          edit: "/wf/wfConsumerCorp/edit",
          queryById: "/wf/wfConsumerCorp/queryById",

          getAuzDevs: "/wf/wfConsumerCorp/getAuzDevs",
          devList: "/device/devList/list",
          vehicleList: "/wf/corpVehicle/list",
          consumerUserList: "/custom/user/list",

          auzEdit: "/wf/wfConsumerCorp/auzEdit",
        },
        pcaData: '',
        disableMixinCreated: true,
        userCount: 0,
        vehicleCount: 0,
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
      childrenFilter () {
        console.log(this.model);
        return {
          corpId: this.model.id
        }
      },
    },
    created () {
      if (this.disabled) {
        this.columns.pop();
      }
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      this.pcaData = new Area()

    },
    methods: {
      getCount () {
        if (!this.model.id) {
          return;
        }
        getAction(this.url.consumerUserList, { corpId: this.model.id, pageSize: 1 }).then(res => {
          if (res.success) {
            this.userCount = res.result.total;
          }
        })

        getAction(this.url.vehicleList, { corpId: this.model.id, pageSize: 1 }).then(res => {
          if (res.success) {
            this.vehicleCount = res.result.total;
          }
        })
      },
      authChange () {
        this.getAuzDevs(this.loadData);
      },
      handleAddCorpAuth () {
        this.$refs.permissionModal.title = `设备授权：[${this.model.corpName}]`
        this.$refs.permissionModal.show(Object.assign(this.model, { authDevs: this.authDevs }))
      },
      cancelAuzBatch () {
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning('请选择一条记录！');
          return false;
        } else {
          let that = this;
          const removed = this.selectedRowKeys.map(devId => ({
            devId,
            corpId: that.model.id
          }));
          that.$confirm({
            title: "确认取消授权",
            content: "是否取消所有选中设备的授权?取消后仍可重新授权。",
            onOk: function () {
              that.handleCancelAuz(removed);
            }
          });
        }
      },
      cancelAuz (record) {
        const removed = [{
          devId: record.id,
          corpId: this.model.id
        }];
        this.handleCancelAuz(removed);
      },
      handleCancelAuz (removed) {
        httpAction(this.url.auzEdit, {
          removed
        }, 'put').then(res => {
          if (res.success) {
            this.$message.success('取消授权成功')
            this.getAuzDevs(this.loadData);
          } else {
            this.$message.error(res.message)
          }
        });
      },
      getAuzDevs (fn) {
        if (!this.model.id) {
          return;
        }
        getAction(this.url.getAuzDevs, { corpId: this.model.id }).then(res => {
          if (res.success) {
            this.authDevs = res.result;
            fn && fn();
          } else {
            this.$message.error(res.message)
          }
        })
      },
      loadData (arg) {
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1
        }
        this.onClearSelected()
        var params = this.getQueryParams() //查询条件
        params.id = this.authDevs.join(',') + ',noid';
        this.loading = true
        getAction(this.url.devList, params).then(res => {
          if (res.success) {
            this.devDataList = res.result.records
            this.ipagination.total = res.result.total
          }
          this.loading = false
        })
      },
      payStrategyChange (value) {
        if (value === '1') {
          this.model.overUsage = 0;
        } else {
          this.model.overUsage = -1;
        }
      },
      validateShortname (rule, value, callback) {
        var params = {
          tableName: '`iwt-wf`.wf_consumer_corp',
          fieldName: 'short_name',
          fieldVal: value,
          dataId: this.model.id
        };
        duplicateCheck(params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback("企业简称已存在!")
          }
        })
      },
      getPcaText (code) {
        return this.pcaData.getText(code);
      },
      add () {
        this.edit(this.modelDefault);
      },
      edit (record, tab) {
        this.model = Object.assign({}, record);
        this.visible = true;
        this.getAuzDevs(this.loadData);
        this.getCount();
        if (tab) {
          this.activeTab = tab
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            const parms = Object.assign({}, this.model);
            if (parms.files) {
              parms.files = JSON.stringify(parms.files);
            }
            httpAction(httpurl, parms, method).then((res) => {
              if (res.success) {
                that.$message.success('保存成功');
                that.model = { ...that.model, ...res.result };
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      handleTabChange (key) {
        this.activeTab = key; // 更新选中的标签
        if ('1' === key) {
          this.getAuzDevs(this.loadData);
          this.getCount();
        }
      },
    }
  }
</script>